export default {
    account_purge_account_title: "Re-sincronización de la información del backend",
    account_purge_account_label: "¿Desea eliminar la información del backend y volver a sincronizarla?",
    account_purge_account_success_response: "La información ha sido resincronizada",
    account_purge_account_error_response: "No ha sido posible resincronizar la información debido a un error",
    account_purge_account_resync: "Vuelva a sincronizar",
};